import "./utils/consoleGate";
import { initTelemetry } from "./telemetry";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "./contexts/ThemeContext";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import axios from "axios";

initTelemetry();

// Configure axios to send cookies by default (for refresh token cookies)
axios.defaults.withCredentials = true;
// Bypass ngrok browser warning page that strips CORS headers.
axios.defaults.headers.common["ngrok-skip-browser-warning"] = "true";

// Ensure native fetch calls also include the ngrok bypass header.
const nativeFetch = window.fetch.bind(window);
window.fetch = (input, init = {}) => {
  const url =
    typeof input === "string"
      ? input
      : input?.url || "";
  // ngrok issues tunnels under multiple TLDs (ngrok-free.app, ngrok-free.dev,
  // ngrok.io, ngrok.app, ...) — match "ngrok" generally instead of one
  // specific domain, since the exact tunnel domain changes on every restart.
  const shouldAddNgrokHeader = url.includes("ngrok");
  if (!shouldAddNgrokHeader) {
    return nativeFetch(input, init);
  }
  const headers = new Headers(init.headers || {});
  if (!headers.has("ngrok-skip-browser-warning")) {
    headers.set("ngrok-skip-browser-warning", "true");
  }
  return nativeFetch(input, { ...init, headers });
};

// Handle ResizeObserver loop error
const resizeObserverError = new Error('ResizeObserver loop completed with undelivered notifications.');
const originalError = console.error;
console.error = (...args) => {
  if (args[0] === resizeObserverError.message) {
    return;
  }
  originalError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
